import { Box } from '@branch-messenger/willow-ui'
import styled, { css } from 'styled-components'

const disabledStyles = css`
  pointer-events: none;
  & * {
    pointer-events: none;
  }
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.6);
    pointer-events: none;
    z-index: 1;
  }
`
export const PersonalInfoItemContainer = styled(Box).attrs({
  $display: 'flex',
  $direction: 'column',
  $align: 'initial',
  $gap: 4,
  $py: 6,
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray};
  position: relative;
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
  &[data-is-editing='false']:has(~ &[data-is-editing='true']) {
    ${disabledStyles}
  }
  &[data-is-editing='true'] {
    & ~ [data-is-editing='false'] {
      ${disabledStyles}
    }
  }
`

export const PersonalInfoItemHeadingContainer = styled(Box).attrs({
  $display: 'flex',
  $gap: 4,
  $justify: 'space-between',
})``

export const PersonalInfoTitleContainer = styled(Box).attrs({
  $display: 'flex',
  $direction: 'column',
  $align: 'initial',
  $gap: 2,
})``

export const PersonalInfoFormContainer = styled(Box).attrs({
  $display: 'flex',
  $direction: 'column',
  $align: 'flex-start',
  $gap: 6,
  as: 'form',
})`
  max-width: 560px;
`
